export default {
	namespaced: true,
	state:      () => ({
		assignPlayerModalVisible: false,
		assignPlayerModalData:    {},
		latestTagsModalVisible:   false,
	}),
	mutations: {
		showAssignPlayerModal(state, data) {
			state.assignPlayerModalData = data;
			state.assignPlayerModalVisible = true;
		},
		hideAssignPlayerModal(state) {
			state.assignPlayerModalVisible = false;
			state.assignPlayerModalData.data = {};
		},
		showLatestTagsModal(state) {
			state.latestTagsModalVisible = true;
		},
		hideLatestTagsModal(state) {
			state.latestTagsModalVisible = false;
		},
	},
	actions: {
		showAssignPlayerModal: ({ commit }, data) => {
			commit('showAssignPlayerModal', data);
		},
		hideAssignPlayerModal: ({ commit }) => {
			commit('hideAssignPlayerModal');
		},
		showLatestTagsModal: ({ commit }, data) => {
			commit('showLatestTagsModal', data);
		},
		hideLatestTagsModal: ({ commit }) => {
			commit('hideLatestTagsModal');
		},
	},
	getters: {
		assignPlayerModalVisible: (state) => state.assignPlayerModalVisible,
		assignPlayerModalData:    (state) => state.assignPlayerModalData,
		latestTagsModalVisible:   (state) => state.latestTagsModalVisible,
	},
};
